module.exports = __webpack_public_path__ + "img/logo.805ebc50.png";